import CharacterSlotHide from './CharacterSlotHide';
import ButtonSimple from './buttons/ButtonSimple';

export default class CharactersListHide extends Phaser.Group {
  constructor(game, charData) {
    super(game);

    this.charData = charData;
    this.slotsAmount = charData.length;
    this.offset = 0; // x offset to move everything left when check button is displayed

    const dx = 150;
    const x0 = -(this.slotsAmount - 1) * 0.5 * dx;
    this.slots = {};
    for (let i = 0; i < this.slotsAmount; i++) {
      const id = charData[i].id;
      const slot = new CharacterSlotHide(this.game, id);
      slot.x = x0 + i * dx;
      slot.destX = slot.x;
      this.addChild(slot);
      this.slots[id] = slot;
    }

    //
    this.createCheckButton();

    this.createPanel();
  }

  setSlotsPositions() {
    let count = 0;
    for (const key in this.slots) {
      if (this.slots.hasOwnProperty(key)) {
        count++;
      }
    }

    const dx = 150;
    const x0 = -(count - 1) * 0.5 * dx;
    let i = 0;
    for (const key in this.slots) {
      if (this.slots.hasOwnProperty(key)) {
        this.slots[key].destX = x0 + i * dx;
        i++;
      }
    }
  }

  setArrowsVisibility(visible) {
    for (const key in this.slots) {
      if (this.slots.hasOwnProperty(key)) {
        this.slots[key].setArrowVisibility(visible);
      }
    }
  }

  setArrowsAnim(visible) {
    for (const key in this.slots) {
      if (this.slots.hasOwnProperty(key)) {
        this.slots[key].setArrowsAnim(visible);
      }
    }
  }

  getSlot(characterId) {
    if (!isNaN(characterId)) {
      characterId = this.charData[characterId].id;
    }
    return this.slots[characterId];
  }

  revealCharacter(characterId) {
    this.getSlot(characterId).revealCharacter();

    this.game.time.events.add(1000, this.handleRevealEnd, this, characterId);
  }

  handleRevealEnd(characterId) {
    delete this.slots[characterId];
    this.setSlotsPositions();
  }

  enlargeCharacter(characterId) {
    this.getSlot(characterId).enlarge();
  }

  normalizeCharacter(characterId) {
    this.getSlot(characterId).normalize();
  }

  pulseCharacter(characterId, repeat) {
    this.getSlot(characterId).pulse(repeat);
  }

  getSlotForCharacter(characterId) {
    return this.getSlot(characterId);
  }

  showDragHand(characterId) {
    const slot = this.getSlot(characterId);
    this.hand = this.game.make.image(slot.x, slot.y, 'ui_character_icons', 'hand');
    this.hand.anchor.set(0, 0.5);
    this.hand.alpha = 0;
    this.addChild(this.hand);

    this.game.time.events.add(500, this.animateHand, this, characterId);
    this.game.time.events.add(2000, this.animateHand, this, characterId);
    this.game.time.events.add(3500, this.animateHand, this, characterId);
    this.game.time.events.add(5000, this.handleHandAnimEnd, this, characterId);
  }

  animateHand(characterId) {
    if (this.hand) {
      const slot = this.getSlot(characterId);

      this.hand.alpha = 0;
      this.hand.y = slot.y;
      this.game.add.tween(this.hand).to({ alpha: 1 }, 100, null, true);
      this.game.add.tween(this.hand).to({ y: '+200' }, 1500, null, true);
      this.game.add.tween(this.hand).to({ alpha: 0 }, 100, null, true, 1400);
    }
  }

  handleHandAnimEnd(characterId) {
    if (this.hand) {
      this.showArrow(characterId);
    }
  }

  hideDragHand(characterId) {
    characterId;
    this.hand.destroy();
    this.hand = null;
  }

  hideArrow(characterId) {
    this.getSlot(characterId).setArrowVisibility(false);
  }

  showArrow(characterId) {
    this.getSlot(characterId).setArrowVisibility(true);
  }

  lock() {
    for (const key in this.slots) {
      if (this.slots.hasOwnProperty(key)) {
        const slot = this.slots[key];
        if (!slot.isEmpty) {
          slot.lock();
        }
      }
    }
  }

  unlock() {
    for (const key in this.slots) {
      if (this.slots.hasOwnProperty(key)) {
        const slot = this.slots[key];
        if (!slot.isEmpty) {
          slot.unlock();
        }
      }
    }
  }

  // check button
  createCheckButton() {
    this.btnCheck = new ButtonSimple({ game: this.game, up: 'btn_check', over: 'btn_check' });
    const dx = 150;
    this.btnCheck.x = -(this.slotsAmount - 1) * 0.5 * dx + this.slotsAmount * dx;
    this.btnCheck.y = 5;

    this.addChild(this.btnCheck);
    this.btnCheck.visible = false;
  }

  createPanel() {
    this.panel = this.game.make.group();
    this.panelDestWidth = (this.slotsAmount + 1) * 150;
    this.panel.x = -this.panelDestWidth * 0.5 + 75;
    this.panel.y = 8;

    this.panelLeft = this.game.make.image(0, 0, 'ui_various', 'top_panel_left');
    this.panelLeft.anchor.set(0, 0.5);
    this.panelRight = this.game.make.image(0, 0, 'ui_various', 'top_panel_right');
    this.panelRight.anchor.set(0, 0.5);
    this.panelMid = this.game.make.image(0, 0, 'ui_various', 'top_panel_middle');
    this.panelMid.anchor.set(0, 0.5);

    this.panel.addChild(this.panelLeft);
    this.panel.addChild(this.panelMid);
    this.panel.addChild(this.panelRight);

    this.addChildAt(this.panel, 0);
    this.panel.visible = false;
  }

  handleBtnCheck() {
    this.btnCheck.onInputDown.remove(this.handleBtnCheck, this);
    this.hideCheckButton();
    this.game.state.getCurrentState().handleButtonContinue();
  }

  showCheckButton() {
    this.btnCheck.onInputDown.add(this.handleBtnCheck, this);

    if (this.tween1) {
      this.tween1.stop();
      this.tween2.stop();
      this.tween3.stop();
    }

    this.btnCheck.visible = true;
    this.btnCheck.scale.set(0);
    this.tween1 = this.game.add
      .tween(this.btnCheck.scale)
      .to({ x: 1, y: 1 }, 300, Phaser.Easing.Back.Out, true);

    // move everything left
    this.startX = this.game.width * 0.5;
    this.offset = -75;
    this.tween2 = this.game.add.tween(this).to({ x: this.startX - 75 }, 300, null, true);

    // tween panel
    this.panel.visible = true;
    this.panelLeft.width = 0;
    this.panelMid.width = 0;
    this.panelRight.width = 0;
    this.panelWidth = 0;
    const destWidth = (this.slotsAmount + 1) * 150;
    this.tween3 = this.game.add
      .tween(this)
      .to({ panelWidth: destWidth }, 300, Phaser.Easing.Quadratic.Out, true);
    this.tween3.onUpdateCallback(this.handlePanelWidthUpdate, this);
  }

  handlePanelWidthUpdate(tween, value, tweenData) {
    tween;
    tweenData;
    value;

    const w1 = Math.max(0, this.panelWidth - 160); // width of middle part
    const w0 = (this.panelWidth - w1) * 0.5; // width of the side part
    this.panelLeft.width = w0;
    this.panelMid.x = w0;
    this.panelMid.width = w1;
    this.panelRight.x = w0 + w1;
    this.panelRight.width = w0;
  }

  hideCheckButton() {
    if (this.tween1) {
      this.tween1.stop();
      this.tween2.stop();
    }

    this.tween1 = this.game.add
      .tween(this.btnCheck.scale)
      .to({ x: 0, y: 0 }, 300, Phaser.Easing.Back.In, true);
    this.tween1.onComplete.add(this.handleCheckButtonHideEnd, this);

    // move everything left
    this.offset = 0;
    this.tween2 = this.game.add.tween(this).to({ x: this.startX }, 300, null, true);

    // tween panel
    this.tween3 = this.game.add
      .tween(this)
      .to({ panelWidth: 0 }, 300, Phaser.Easing.Quadratic.In, true);
    this.tween3.onUpdateCallback(this.handlePanelWidthUpdate, this);
  }

  handleCheckButtonHideEnd() {
    this.btnCheck.visible = false;
    this.panel.visible = false;
  }
}
